import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AuthModule } from '@freelancer/auth';
import { TrackingModule } from '@freelancer/tracking';
import { CookieModule } from '@laurentgoudet/ngx-cookie';
import { ABTest } from './abtest.service';

@NgModule({
  imports: [HttpClientModule, AuthModule, TrackingModule, CookieModule],
})
export class ABTestModule {
  static initialize(): ModuleWithProviders {
    return {
      ngModule: ABTestModule,
      providers: [ABTest],
    };
  }
}
